import * as THREE from 'three';
export class loadRay{
    scene;
    ray;
    mouse;
    camera;
    container;
    model;
    individual;
    restore;
    constructor() {
        this.mouse = new THREE.Vector2();
    }
    heid(individual){
        this.individual = individual;
    }
    manualRestore(restore){
        this.restore = restore;
    }
    bind(camera,scene,container,model){

        this.model = model
        this.ray = new THREE.Raycaster();
        this.camera = camera;
        this.scene = scene;
        this.container = container;
        this.container.addEventListener("mousemove",this.onDocumentmousemove.bind(this),false);
        this.container.addEventListener("click",this.onDocumentmousedown.bind(this),false);
        this.container.addEventListener("touchstart", this.onDocumenttouchdown.bind(this), {
            passive: false
        });
    }


    onDocumentmousedown(event){
        event.preventDefault();
        let self = this;
        let getBoundingClientRect = self.container.getBoundingClientRect();
        self.mouse.x=((event.clientX - getBoundingClientRect .left) / self.container.offsetWidth) * 2 - 1;
        self.mouse.y=-((event.clientY - getBoundingClientRect .top) / self.container.offsetHeight) * 2 + 1;
        self.ray.setFromCamera(self.mouse,self.camera);
        let intersections = self.ray.intersectObjects(self.scene.children,true);
        if(intersections!=null&&intersections.length>0){
            console.log(intersections);
            for (let i = 0; i < intersections.length; i++) {
                intersections[i].object.action && intersections[i].object.action();
            }
        }
    }

    onDocumentmousemove(event){
        event.preventDefault();
        this.ray.setFromCamera(this.mouse,this.camera);
        this.mouse.set((event.clientX/window.innerWidth)*2-1,-(event.clientY/window.innerHeight)*2+1);
        // let intersections = this.ray.intersectObjects(this.scene.children);

    }

    onDocumenttouchdown(event) {
        event.preventDefault();
        let self = this;
        if (event.touches.length === 1) {
            let getBoundingClientRect = self.container.getBoundingClientRect();
            self.mouse.x=((event.touches[0].clientY - getBoundingClientRect.top) / self.container.offsetWidth) * 2 - 1;
            self.mouse.y=-((self.container.offsetHeight - event.touches[0].clientX - getBoundingClientRect.left) / self.container.offsetHeight) * 2 + 1;
            self.ray.setFromCamera(self.mouse, self.camera);
            let intersects = self.ray.intersectObjects(self.scene.children,true);
            if (intersects.length > 0) {
                console.log(intersects)
                for (let i = 0; i < intersects.length; i++) {
                    intersects[i].object.action && intersects[i].object.action();
                }
            }
        }
    }
}
